import React, { useEffect, useState } from "react";
import { getData, postData } from "../../services/api.service";
import AdminBurgers from "./components/AdminBurgers";
import {
  swalAlertDanger,
  swalAlertInfo,
  swalAlertSuccess,
  swalConfirmationAlert,
} from "../../components/common/Alerts";
import { FaPlus } from "react-icons/fa";
import ModalWindow from "../../components/ModalWindow";
import FormCreateBurger from "./components/forms/FormCreateBurger";
import FormCreateSize from "./components/forms/FormCreateSize";
import FormCreateTopping from "./components/forms/FormCreateTopping";
import Logo from "../../assets/img/Logo2.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Image from "../../assets/img/Logo.png";
import AdminToppingsCheeses from "./components/AdminToppingsCheeses";
import BackButton from "../../components/common/BackButton";
import { useSelector } from "react-redux";


export const AdminProducts = () => {
  const navigate = useNavigate();
  const { id_branch } = useParams();
  const dataUser = useSelector((state) => state.user.dataUser);
  const [burguers, setBurgers] = useState([]);
  const [toppings, setToppings] = useState([]);
  const [cheeses, setCheeses] = useState([]);
  const [sideItems, setSideItems] = useState([]);

  const [showModalCreateType, setShowModalCreateType] = useState(false);
  const [showModalCreateSize, setShowModalCreateSize] = useState(false);
  const [showModalCreateTopping, setShowModalCreateTopping] = useState(false);
  
  const fetchData = async () => {
    if (dataUser === null || dataUser.role_id !== 1) {
      navigate("/");
    }

    const resBurguers = await getData(`/api/get_burguer_types/${id_branch}`);
    const resToppings = await getData(`/api/get_toppings_types/${id_branch}`);
    const resCheese = await getData(`/api/get_cheese_types/${id_branch}`);
    const resSideItems = await getData(`/api/get_items_addons_by_side_item/1/${id_branch}`); //Forzado a 1 (papas)

    if (resBurguers) {
      setBurgers(resBurguers.data.burger_types);
    } else {
      console.error("Error fetching burger types");
    }
    if (resToppings) {
      setToppings(resToppings.data.toppings_types);
    } else {
      console.error("Error fetching toppings types");
    }
    if (resCheese) {
      setCheeses(resCheese.data.cheese_types);
    } else {
      console.error("Error fetching cheese types");
    }
    if (resSideItems) {
      setSideItems(resSideItems.data);
    } else {
      console.error("Error fetching side items");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleCreateBurger = async (data) => {
    const dataWithBranch = { ...data, id_branch };
    await postData("/api/admin/create_burguer_type", dataWithBranch).then((res) => {
      if (res.status === 200) {
        swalAlertSuccess("Tipo de hamburguesa creado exitosamente", "", () => {
          setShowModalCreateType(false);
          fetchData();
        });
      } else {
        swalAlertDanger(
          "Error al crear el tipo de hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleDeleteBurger = async (item) => {
    const data = item.id;
    swalConfirmationAlert(
      "¿Estás seguro de eliminar este producto?",
      "No podrás deshacer esta acción",
      () => {
        postData("/api/admin/delete_burguer_type", data).then((res) => {
          if (res.status === 200) {
            swalAlertSuccess(
              "Tipo de hamburguesa eliminado exitosamente",
              "",
              () => {
                fetchData();
              }
            );
          } else {
            swalAlertDanger(
              "Error al eliminar el tipo de hamburguesa",
              res.msg,
              () => {}
            );
          }
        });
      }
    );
  };

  const handleCreateSize = async (data) => {
    const dataWithBranch = { ...data, id_branch };
    postData("/api/admin/create_burguer_sizes", dataWithBranch).then((res) => {
      if (res.status === 200) {
        swalAlertSuccess(
          "Tamaño de hamburguesa creado exitosamente",
          "",
          () => {
            setShowModalCreateSize(false);
            fetchData();
          }
        );
      } else if (res.status === 203) {
        swalAlertInfo("Atención", res.msg, () => {});
      } else {
        swalAlertDanger(
          "Error al crear el tamaño de hamburguesa",
          res.msg,
          () => {}
        );
      }
    });
  };

  const handleCreateTopping = async (data) => {
    const dataWithBranch = { ...data, id_branch };
    postData("/api/admin/create_topping", dataWithBranch).then((res) => {
      if (res.status === 200) {
        swalAlertSuccess("Topping creado exitosamente", "", () => {
          setShowModalCreateTopping(false);
          fetchData();
        });
      } else if (res.status === 203) {
        swalAlertInfo("Atención", res.msg, () => {});
      } else {
        swalAlertDanger("Error al crear el topping", res.msg, () => {});
      }
    });
  };

  return (
    <>
      <div className="container mt-5">
        <Link to="/">
          <img src={Image} alt="logo" className="login-logo" />
        </Link>
        <div>
          <button
            className="btn btn-outline-light mb-3"
            onClick={() => navigate(`/home/admin_panel/${id_branch}`)}
          >
            ← Volver al Panel
          </button>
        </div>
        <div className="text-center">
          <h3 style={{ color: "#E8D9CD" }}>ADMINISTRADOR DE PRODUCTOS</h3>
        </div>

        <div className="mt-5">
          <div className="row justify-content-center text-center gap-3 gap-md-0">
            <div className="col-12 col-md-4 mb-3">
              <h5 className="mb-3" style={{ color: "#E8D9CD" }}>
                Tipos de hamburguesas
              </h5>
              <button
                className="btn btn-success w-100 rounded-pill fw-bold py-2"
                style={{
                  backgroundColor: "#E35E1E",
                  border: "none",
                  color: "#22263E",
                }}
                onClick={() => setShowModalCreateType(true)}
              >
                <FaPlus /> Crear hamburguesa
              </button>
            </div>

            <div className="col-12 col-md-4 mb-3">
              <h5 className="mb-3" style={{ color: "#E8D9CD" }}>
                Tamaños
              </h5>
              <button
                className="btn btn-success w-100 rounded-pill fw-bold py-2"
                style={{
                  backgroundColor: "#E8D9CD",
                  border: "none",
                  color: "#22263E",
                }}
                onClick={() => setShowModalCreateSize(true)}
              >
                <FaPlus /> Nuevo tamaño
              </button>
            </div>

            <div className="col-12 col-md-4 mb-3">
              <h5 className="mb-3" style={{ color: "#E8D9CD" }}>
                Toppings
              </h5>
              <button
                className="btn btn-success w-100 rounded-pill fw-bold py-2"
                style={{
                  backgroundColor: "#48B060",
                  border: "none",
                  color: "#22263E",
                }}
                onClick={() => setShowModalCreateTopping(true)}
              >
                <FaPlus /> Nuevo topping
              </button>
            </div>
          </div>

          <div className="mt-4">
            <AdminBurgers
              burgers={burguers}
              handleDelete={handleDeleteBurger}
              id_branch={id_branch}
            />
          </div>
          <div className="mt-4">
            <AdminToppingsCheeses
              toppings={toppings}
              cheeses={cheeses}
              sideItems={sideItems}
              id_branch={id_branch}
            />
          </div>
        </div>
        <img src={Logo} alt="LogoBottom" className="w-50 d-flex mx-auto mt-5" />
      </div>

      <ModalWindow
        body={<FormCreateBurger handleCreate={handleCreateBurger} />}
        setModalOpen={setShowModalCreateType}
        modalOpen={showModalCreateType}
        footer={"Estará disponible para que tus clientes puedan elegirlo"}
      />
      <ModalWindow
        body={<FormCreateSize handleCreate={handleCreateSize} />}
        setModalOpen={setShowModalCreateSize}
        modalOpen={showModalCreateSize}
        footer={"Estará disponible para tus hamburguesas"}
      />
      <ModalWindow
        body={<FormCreateTopping handleCreateTopping={handleCreateTopping} />}
        setModalOpen={setShowModalCreateTopping}
        modalOpen={showModalCreateTopping}
        footer={"Estará disponible para añadir en tus hamburguesas"}
      />
    </>
  );
};

export default AdminProducts;
